// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Traduzioni piani - Italiano
 */
export const plansTranslationsIt = {
  'plans.compare.title': 'Scegli il tuo piano',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.free.price': '$0 / mese',
  'plans.compare.foundation.price': '$15 / mese',
  'plans.compare.pro.price': '$19 / mese',
  'plans.compare.foundation.badge': '150 posti limitati',
  'plans.compare.cta.foundation': 'Diventa Founder',
  'plans.compare.cta.pro': 'Passa a PRO',
  'plans.compare.active': 'Piano attuale',
  'plans.compare.limited': '',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.limit.title.messages': 'Limite messaggi raggiunto',
  'plans.limit.message.messages': 'Hai raggiunto il limite di messaggi del tuo piano. Passa a FOUNDATION o PRO per continuare.',
  'plans.limit.title.storage': 'Limite di archiviazione',
  'plans.limit.message.storage': 'Hai raggiunto il limite di archiviazione. Migliora il piano per caricare più file.',
  'plans.limit.title.invitations': 'Limite inviti',
  'plans.limit.message.invitations': 'Hai raggiunto il limite di inviti. Migliora il piano per invitare più contatti.',
  'plans.founder.remaining': 'Rimangono {count} posti Founder',
  'plans.founder.remaining_last': 'Ultimi {count} posti Founder',
  'plans.founder.remaining_limited': 'Posti limitati: ne restano {count}',
  'plans.founder.remaining_very_low': 'Solo {count} posti Founder rimasti',
  'plans.founder.soldout': 'Founder esaurito',
  'plans.limit.reached': 'Limite raggiunto — Migliora piano',
  'plans.compare.pro.adjustment_notice': 'Il prezzo può essere adeguato in base alle condizioni del servizio.',
  'plans.compare.institucional.price': 'Prezzo personalizzato',
  'plans.compare.institucional.title': 'Titolo',
  'plans.compare.yourPlan': 'Il tuo piano',
  'plans.modal.title': 'Aggiorna piano',
  'plans.modal.comparison_title': 'Confronto piani',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.modal.free.line1': '30.000 caratteri al mese per account.',
  'plans.modal.free.line2': 'Fino a 2 contatti per utente.',
  'plans.modal.free.line3': 'Fino a 2 conversazioni attive per account.',
  'plans.modal.free.line4': 'Nessun allegato né spazio di archiviazione.',
  'plans.modal.free.line5': 'Nessuna esportazione dati.',
  'plans.modal.free.line6': 'Cronologia messaggi fino a 30 giorni.',
  'plans.modal.free.line7': 'Solo 1 dispositivo per utente.',
  'plans.modal.premium.line1': '300.000 caratteri al mese per account.',
  'plans.modal.premium.line2': 'Fino a 100 contatti per utente.',
  'plans.modal.premium.line3': 'Conversazioni e chat illimitate (tenant).',
  'plans.modal.premium.line4': 'Fino a 50 MB di archiviazione (tenant).',
  'plans.modal.premium.line5': 'Fino a 3 dispositivi per utente.',
  'plans.modal.premium.line6': 'Inviti illimitati (tenant).',
  'plans.modal.premium.line7': 'Include esportazione, traduzione automatica e file entro i limiti del piano.',
  'plans.modal.premium_block_heading': 'Limiti d\'uso del motore (premium)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Programma Founder',
  'plans.modal.foundation.categories_title': 'Categorie Founder ({slots} posti)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': 'Posizione 1–25',
  'plans.modal.foundation.cat_legendary_desc': 'I primi a sostenere il progetto. Massima priorità storica.',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': 'Posizione 26–75',
  'plans.modal.foundation.cat_early_desc': 'Supporto anticipato con riconoscimento speciale.',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': 'Posizione 76–150',
  'plans.modal.foundation.cat_std_desc': 'Posto Founder tra le 150 posizioni.',
  'plans.modal.foundation.advantages_title': 'Vantaggi Founder',
  'plans.modal.foundation.adv1': 'Accesso al pool Founder limitato ({slots} posti numerati).',
  'plans.modal.foundation.adv2': 'Riconoscimento come utente fondatore di ArChat.',
  'plans.modal.foundation.adv3': 'Badge e presenza Founder nell\'esperienza prodotto.',
  'plans.modal.foundation.adv4': 'Priorità storica e status in base alla tua posizione (1–150).',
  'plans.modal.foundation.adv5': 'Beneficio permanente legato al tuo accesso Founder finché vale la policy vigente.',
  'plans.modal.pro.tagline': 'Premium standard — senza componente Founder',
  'plans.badges.foundation': 'Founder',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': 'Piano gratuito',
  'plans.free.price': '$0 / mese',
  'plans.free.features.contacts': 'Fino a 2 contatti per utente',
  'plans.free.features.conversations': 'Fino a 2 conversazioni attive per account',
  'plans.free.features.no_export': '30.000 caratteri/mese per account; 34 messaggi/giorno e 1.000/mese; nessuna esportazione',
  'plans.free.features.no_advanced': 'Nessun file o archivio; cronologia 30 giorni; 1 dispositivo per utente',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'Piano Founder',
  'plans.foundation.price': '$15 / mese',
  'plans.foundation.features.contacts': 'Stesso contratto premium di PRO (fino a 100 contatti per utente)',
  'plans.foundation.features.conversations': 'Conversazioni e chat illimitate (tenant); stessi limiti di PRO',
  'plans.foundation.features.badge': 'Programma Founder (150 posti numerati)',
  'plans.foundation.features.support': 'USD 15/mese finché ci sono posti Founder',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'Piano Pro',
  'plans.pro.price': '$19 / mese',
  'plans.pro.features.contacts': 'Fino a 100 contatti per utente',
  'plans.pro.features.conversations': 'Conversazioni e chat illimitate (tenant); 1.667 msg/giorno, 50k/mese',
  'plans.pro.features.export': 'Fino a 50 MB (tenant); esportazione, traduzione automatica e file secondo piano',
  'plans.pro.features.notifications': 'Fino a 3 dispositivi per utente; inviti illimitati (tenant)',
  'plans.actions.free': 'Piano attuale',
  'plans.actions.foundation': 'Diventa Founder',
  'plans.actions.pro': 'Passa a PRO',
  'plans.badges.recommended': 'CONSIGLIATO',
  'plans.badges.limited': 'LIMITATO',
  'plans.payments_disabled.title': 'Abbonamenti',
  'plans.payments_disabled.message': 'Gli abbonamenti vengono attivati gradualmente. Puoi visualizzare i piani disponibili e i relativi vantaggi.',
  'plans.payments_disabled.confirm': 'OK',
};